export const getFormFields = () => {
  return {
    defaultError: '',
    email: '',
    firstName: '',
    lastName: '',
    phoneNumber: '',
    password: '',
    referral: '',
    ssn: '',
    passport: '',
    birthDate: '',
    line1: '',
    line2: '',
    postalCode: '',
    city: '',
    state: '',
    segment: '',
    checkbox: '',
    businessName: '',
    ein: '',
    ownershipPercent: '',
    homeCountry: '',
  }
}



// WEBPACK FOOTER //
// ./src/services/entities/errorService.js